export default __webpack_public_path__ + "static/media/Kollektiv35_StimmeX_Web-24.57a0c5e3.jpg";